module.exports = __webpack_public_path__ + "img/background.17adb73e.png";